import { useTranslation } from 'react-i18next';
import myoshLogo from '../assets/myosh-logo-white-text.svg';

const Sidebar = () => {
  const { t } = useTranslation();
  return (
    <aside
      data-testid="login-sidebar"
      className="flex w-full flex-col gap-4 bg-gradient-to-br from-secondary-1 via-secondary-2 to-secondary-1 px-6 py-4 sm:max-w-xs"
    >
      <img src={myoshLogo} alt={t('login-sidebar-alt')} className="w-40" />
      <h1 className="font-bold text-md text-mono-1 drop-shadow-lg sm:text-lg md:text-xl">
        {t('login-sidebar-tagline')}
      </h1>
    </aside>
  );
};

export default Sidebar;
